/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { EmailProtocolsRequestUpdateEmailRequest, EmailProtocolsUpdateEmailAddressRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Email<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Email
   * @name RequestUpdateCreate
   * @request POST:/email/request_update
   */
  requestUpdateCreate = (data: EmailProtocolsRequestUpdateEmailRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/email/request_update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Email
   * @name UpdateCreate
   * @request POST:/email/update
   */
  updateCreate = (data: EmailProtocolsUpdateEmailAddressRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/email/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
